import { render, staticRenderFns } from "./ResearchOps.vue?vue&type=template&id=488a257c&scoped=true&"
import script from "./ResearchOps.vue?vue&type=script&lang=js&"
export * from "./ResearchOps.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOps.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ResearchOps.vue?vue&type=style&index=1&id=488a257c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488a257c",
  null
  
)

export default component.exports